export default __webpack_public_path__ + "static/media/Helani.22b90699.jpg";